import { Button, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";

export type MapButtonProps = {
  latitude?: string;
  longitude?: string;
};

export const MapButton = (props: MapButtonProps) => {
  const { latitude, longitude } = props;
  return (
    <Tooltip title="View on Map" placement="top">
      <Button
        type="text"
        size="small"
        key="map"
        href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
        target="_blank"
      >
        <GlobalOutlined />
      </Button>
    </Tooltip>
  );
};

export const makeMapButton = (latitude?: string, longitude?: string) => {
  return <MapButton latitude={latitude} longitude={longitude} />;
};
